import { Alert, Button, Text } from '@mantine/core';
import { IconAlertTriangle, IconExternalLink } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { generatedCouponLabels } from '../../helpers/platformLabel';

const PartnerAuthorizationAlert = ({ title, message, authorizationUrl, color = 'yellow', ...rest }) => {
  const platform = useSelector((state) => state.domain.domain?.platform);
  return (
    <Alert color={color} icon={<IconAlertTriangle size={16} />} title={title} {...rest}>
      <Text size="sm" mb={authorizationUrl ? 'sm' : 0}>
        {message}
      </Text>
      {authorizationUrl && (
        <Button
          component="a"
          href={authorizationUrl}
          target="_blank"
          rel="noreferrer"
          size="xs"
          leftSection={<IconExternalLink size={14} />}
        >
          {generatedCouponLabels(platform).reauthorize}
        </Button>
      )}
    </Alert>
  );
};

export default PartnerAuthorizationAlert;
